export const LOADING = 'LOADING';
export const MESSAGE = 'MESSAGE';
export const MESSAGE_RESERVATION = 'MESSAGE_RESERVATION';